import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UserOrdersPage } from './user-orders';

@NgModule({
  declarations: [
    UserOrdersPage,
  ],
  imports: [
    IonicPageModule.forChild(UserOrdersPage),
  ],
  exports: [
    UserOrdersPage
  ]
})
export class UserOrdersModule {}



// WEBPACK FOOTER //
// ./src/pages/user-orders/user-orders.module.ts